/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_OrganizationInputs */

const zh_publish_organization = /** @type {(inputs: Publish_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织`)
};

const en_publish_organization = /** @type {(inputs: Publish_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization`)
};

const es_publish_organization = /** @type {(inputs: Publish_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organización`)
};

/**
* | output |
* | --- |
* | "Organization" |
*
* @param {Publish_OrganizationInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const publish_organization = /** @type {((inputs?: Publish_OrganizationInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_OrganizationInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_publish_organization(inputs)
	if (locale === "en") return en_publish_organization(inputs)
	return es_publish_organization(inputs)
});